var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMulti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.301,
    y: 0.801,
    width: 18.397,
    height: 14.397,
    rx: 1.628,
    stroke: "currentColor",
    strokeWidth: 0.603
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.603,
    d: "M3.627.801h11.747v14.397H3.627z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.476,
    y: 3.614,
    width: 6.047,
    height: 4.085,
    rx: 0.663,
    stroke: "currentColor",
    strokeWidth: 0.603
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC4zMDE0MTgiIHk9IjAuODAxNDE4IiB3aWR0aD0iMTguMzk3MiIgaGVpZ2h0PSIxNC4zOTcyIiByeD0iMS42Mjc2NiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMC42MDI4MzciLz4KPHJlY3QgeD0iMy42MjY2MSIgeT0iMC44MDE0MTgiIHdpZHRoPSIxMS43NDcyIiBoZWlnaHQ9IjE0LjM5NzIiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjAuNjAyODM3Ii8+CjxyZWN0IHg9IjYuNDc2MjIiIHk9IjMuNjEzOTIiIHdpZHRoPSI2LjA0NzE2IiBoZWlnaHQ9IjQuMDg0NjYiIHJ4PSIwLjY2MzEyMSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMC42MDI4MzciLz4KPC9zdmc+Cg==";
export { SvgMulti as ReactComponent };